import { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useToast } from 'contexts';
import { updatePassword } from 'services';
import { useNavigate } from 'react-router-dom';

type ResetPasswordFormInputs = {
  username: string;
  code: string;
  password: string;
  password_confirm: string;
};

export default function ResetPasswordForm({ username }: { username: string }) {
  const { toastify } = useToast();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ResetPasswordFormInputs>();
  const [sending, setSending] = useState(false);
  const navigate = useNavigate();

  const onSubmit: SubmitHandler<ResetPasswordFormInputs> = async data => {
    if (data.password !== data.password_confirm) {
      toastify({
        content: 'As senhas digitadas não são iguais.',
        type: 'error',
      });
      return;
    }

    setSending(true);
    try {
      const result = await updatePassword({ ...data, username });
      if (result) {
        toastify({
          content: 'Senha alterada com sucesso.',
          type: 'success',
        });
      } else {
        toastify({
          content: 'Erro ao atualizar senha, tente novamente mais tarde.',
          type: 'error',
        });
      }
    } catch (error) {
      toastify({
        content: 'Erro ao atualizar senha, tente novamente mais tarde.',
        type: 'error',
      });
    } finally {
      setSending(false);
      navigate('/login');
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <ul>
        <li>
          <label htmlFor="code">Código de Recuperação</label>
          <input
            {...register('code', { required: 'Campo obrigatório.' })}
            id="code"
            name="code"
            type="text"
            autoComplete="false"
            placeholder="Digite o código de recuperação"
          />
          {errors.code && <span role="alert">{String(errors.code.message)}</span>}

          <label htmlFor="password">Nova Senha</label>
          <input
            {...register('password', { required: 'Campo obrigatório.' })}
            id="password"
            name="password"
            type="password"
            autoComplete="false"
            placeholder="Digite a nova senha"
          />
          {errors.password && <span role="alert">{String(errors.password.message)}</span>}

          <label htmlFor="password_confirm">Confirmação de Senha</label>
          <input
            {...register('password_confirm', { required: 'Campo obrigatório.' })}
            id="password_confirm"
            name="password_confirm"
            type="password"
            autoComplete="false"
            placeholder="Digite novamente a senha"
          />
          {errors.password_confirm && <span role="alert">{String(errors.password_confirm.message)}</span>}

          <button type="submit" disabled={sending} className="py-2 px-4">
            Redefinir Senha
          </button>
        </li>
      </ul>
    </form>
  );
}
